import { Box } from "@mui/material";
import Card, { CardGrid } from "../components/Card";
import KpiTile from "../components/KpiTile";
import StatTable from "../components/StatTable";
import StatsGate from "../components/StatsGate";
import { Live } from "../types";
import { useStats } from "../useStats";

const POLL_MS = 15_000;

export default function LiveTab({ query, reloadKey }: { query: string; reloadKey: number }) {
  const state = useStats<Live>("/live", query, reloadKey, POLL_MS);
  return (
    <StatsGate state={state}>
      {(data) => (
        <>
          <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, mb: 2 }}>
            <KpiTile label="Watching in chat rooms" value={data.viewersNow} />
            <KpiTile label="Watching in parties" value={data.partyViewersNow} />
            <KpiTile label="Parties with fans in them now" value={data.activePartiesNow} />
            <KpiTile label="Messages, last 5 min" value={data.messagesLast5Min} />
            <KpiTile label="Reactions, last 5 min" value={data.reactionsLast5Min} />
            <KpiTile label="Open reports" value={data.openReports} />
          </Box>
          <CardGrid>
            <Card title="Busiest rooms right now" wide>
              <StatTable
                rows={data.topRoomsNow}
                getRowId={(r) => `${r.tenant}:${r.gameId}`}
                columns={[
                  { field: "tenant", headerName: "Tenant", flex: 1 },
                  { field: "gameId", headerName: "Game", flex: 1 },
                  { field: "viewers", headerName: "Viewers", type: "number", flex: 1 },
                ]}
              />
            </Card>
          </CardGrid>
        </>
      )}
    </StatsGate>
  );
}
